import { render } from "./PercentLine.vue?vue&type=template&id=6fad413d"
import script from "./PercentLine.vue?vue&type=script&lang=js"
export * from "./PercentLine.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__